import ArrowBack from 'material-ui/svg-icons/navigation/arrow-back';
import autoBind from 'react-autobind';
import {CommentsSection} from '../../comments/components';
import {connect} from 'react-redux';
import {DocumentDownloader} from '../../shared/components';
import {getCurrentUserId} from '../../authentication/selectors';
import {Map} from 'immutable';
import muiThemes from '../../../styles/teamologyTheme';
import {withRouter} from 'react-router';
import {
  LessonDetailContent,
  LessonDetailHeader,
  LessonDetailSideBar,
} from './index';
import {MainContent, PageBody} from '../../layout/components';
import React, {Component, PropTypes} from 'react';
import {
  registerHoverState,
  resetDownloadUrl,
  setDownloadUrl,
  updateHoverState,
} from '../actions';

class CommunityLessonDetailPage extends Component {
  constructor(props, context) {
    super(props, context);
    autoBind(this);
  }

  componentDidMount() {
    const {registerHoverState} = this.props;
    registerHoverState(this.getHoverStateMap().backLink);
  }

  handleDownloadDocument(materialId) {
    this.props.setDownloadUrl(materialId);
  }

  handleDocumentDownloaded() {
    this.props.resetDownloadUrl();
  }

  handleBackNavigation() {
    // The user can get here from the modal on the dashboard on the web or by the '/add-post' route on mobile.
    //  Instead of navigating back, we'll just send the user directly to the dashboard.
    const {router} = this.props;
    router.push('/dashboard');
  }

  getHoverStateMap() {
    return {
      backLink: 'back-link',
    };
  }

  createdByCurrentUser(createdById) {
    return this.props.userId === createdById;
  }

  handleHover(id, value) {
    const {updateHoverState} = this.props;
    updateHoverState(id, value);
  }

  render() {
    const {downloadUrl, hideComments, hoverStates, lessonPlan, loading} = this.props;
    const backLinkId = this.getHoverStateMap().backLink;
    const iconStyle = {
      color: hoverStates.get(backLinkId) ? muiThemes.palette.primary2Color : muiThemes.palette.primary1Color,
    };

    return (
      <PageBody>
        <MainContent loading={loading} hideRainbow>
          <div>
            <div className="lesson-detail-top-bar">
              <div className="lesson-detail-back-link"
                onClick={this.handleBackNavigation}
                onMouseOver={this.handleHover.bind(this, this.getHoverStateMap().backLink, true)}
                onMouseOut={this.handleHover.bind(this, this.getHoverStateMap().backLink, false)}>
                <ArrowBack style={iconStyle} />
              </div>

              {
                // TODO: add this back in when a user is able to edit their post
                //this.createdByCurrentUser(lessonPlan.get('createdById'))
                  //? <RaisedButton className="raised-button--rounded" primary>Edit</RaisedButton>
                  //: <div />
              }
            </div>

            <div className="lesson-detail-container">
              <div className="lesson-detail-header">
                <LessonDetailHeader
                  lessonType={lessonPlan.get('lessonType')}
                  grades={lessonPlan.get('grades')}
                  characterName={lessonPlan.getIn(['character', 'name'])}
                  title={lessonPlan.get('title')}
                  createdBy={lessonPlan.get('createdBy')}
                  createdDate={lessonPlan.get('createdAt')} />
              </div>
              <div className="featured-image">
                <img src={lessonPlan.get('featuredImage')} />
              </div>

              <div className="lesson-detail-body">
                <div className="lesson-detail-content">
                  <LessonDetailContent content={lessonPlan.get('content')} />
                </div>

                <div className="lesson-detail-sidebar">
                  <LessonDetailSideBar
                    materials={lessonPlan.get('materials')}
                    supplies={lessonPlan.get('supplies')}
                    photos={lessonPlan.get('photos')}
                    onDownloadMaterial={this.handleDownloadDocument} />
                </div>
              </div>
            </div>
            { hideComments
            ? <div />
            : <div>
              <div className="lesson-detail-separator" />
              <div className="lesson-detail-comments">
                <CommentsSection disabled />
              </div>
            </div>
            }
          </div>
        </MainContent>
        <DocumentDownloader downloadUrl={downloadUrl} onDocumentDownloaded={this.handleDocumentDownloaded} />
      </PageBody>
    );
  }
}

CommunityLessonDetailPage.defaultProps = {
  hideComments: false,
}

CommunityLessonDetailPage.propTypes = {
  downloadUrl: PropTypes.string.isRequired,
  hideComments: PropTypes.bool,
  hoverStates: PropTypes.instanceOf(Map).isRequired,
  lessonPlan: PropTypes.instanceOf(Map).isRequired,
  loading: PropTypes.bool.isRequired,
  registerHoverState: PropTypes.func.isRequired,
  resetDownloadUrl: PropTypes.func.isRequired,
  router: PropTypes.object.isRequired,
  setDownloadUrl: PropTypes.func.isRequired,
  updateHoverState: PropTypes.func.isRequired,
  userId: PropTypes.number.isRequired,
};

function mapStateToProps(state) {
  const {showLessonDetail} = state.features.lessonDetail.pages;
  return {
    downloadUrl: showLessonDetail.get('downloadUrl'),
    hoverStates: showLessonDetail.get('hoverStates'),
    loading: showLessonDetail.get('loading'),
    userId: getCurrentUserId(state),
  };
}

export default withRouter(connect(
  mapStateToProps,
  {
    registerHoverState,
    resetDownloadUrl,
    setDownloadUrl,
    updateHoverState,
  }
)(CommunityLessonDetailPage));



// WEBPACK FOOTER //
// ./app/features/lessonDetail/components/CommunityLessonDetailContents.js